import { render, staticRenderFns } from "./Quotations.vue?vue&type=template&id=9a0474fe&scoped=true"
import script from "./Quotations.vue?vue&type=script&lang=js"
export * from "./Quotations.vue?vue&type=script&lang=js"
import style0 from "./Quotations.vue?vue&type=style&index=0&id=9a0474fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0474fe",
  null
  
)

export default component.exports